export default __webpack_public_path__ + "static/media/no-orders.00e30be9.svg";